import script from "./ContactosPreviosSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactosPreviosSelector.vue?vue&type=script&lang=ts&setup=true"

import "./ContactosPreviosSelector.vue?vue&type=style&index=0&id=09741436&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09741436"]])

export default __exports__